import { Scale } from "lucide-react";
import AgreementsHistory from "@/components/legal/AgreementsHistory";

export default function MerchantLegalAgreements() {
  return (
    <div data-testid="merchant-legal-page">
      <div className="pf-chip pf-chip-lav"><Scale className="w-3 h-3" /> Account</div>
      <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mt-3 text-slate-900">Terms &amp; Agreements</h2>
      <p className="text-sm text-slate-600 mt-1 mb-6">Your Terms history: every Terms version your business accepted, with a downloadable copy and acceptance certificate.</p>
      <AgreementsHistory showMarketing />
    </div>
  );
}
